import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as LogoIcon } from "../../../icons/logo-icon.svg";
import LeaderboardBtn from "../LeaderboardBtn/LeaderboardBtn";

const HeaderLogoAuthed = () => {
  const navigate = useNavigate();
  return (
    <div className="header-logo-authed">
      <LogoIcon
        className="logo"
        onClick={() => navigate("/orders/AWAITING")}
      />
      <LeaderboardBtn />
    </div>
  );
};

export default HeaderLogoAuthed;
